import { FC, useCallback } from 'react';
import { audioCallLocalStream } from 'services/voip';
import socket from 'services/socket';
import { SOCKET_ACTIONS, MESSAGE_TYPES } from '@medicusunion/front-utils';
import webrtc from 'services/webrtc';
import { AudioCallStatuses } from 'constants/voip';

import { audioRouteButtonRef } from '../_refs';
import MeetingAction from '../MeetingAction';

interface IProps {
  status: AudioCallStatuses | undefined;
  isEnabled: boolean;
  onChange(value: boolean): void;
}

const CameraButton: FC<IProps> = ({ status, isEnabled, onChange }) => {
  const onToggleVideo = useCallback(async () => {
    const value = !isEnabled;

    socket.sendToPeer(SOCKET_ACTIONS.SWITCH_ACTION, {
      type: MESSAGE_TYPES.video,
      value
    });

    if (value) {
      audioRouteButtonRef.current?.forceEnableSpeaker();
      const stream = await webrtc.getUserMedia({
        isVideoEnabled: true,
        isAudioEnabled: false
      });

      if (stream && audioCallLocalStream.current) {
        const oldTrack = audioCallLocalStream.current?.getVideoTracks()?.[0];
        const newTrack = stream?.getVideoTracks()?.[0];

        if (oldTrack) {
          audioCallLocalStream.current.removeTrack(oldTrack);
        }

        audioCallLocalStream.current.addTrack(newTrack);

        webrtc.addOrReplaceTrackToPcs(
          audioCallLocalStream.current,
          'video',
          oldTrack
        );
      }
    } else {
      const track = audioCallLocalStream.current?.getVideoTracks()?.[0];

      if (track && audioCallLocalStream.current) {
        webrtc.removeTrackFromPcs(audioCallLocalStream.current, 'video');
        track.stop();
      }
    }

    onChange(value);
  }, [isEnabled, onChange]);

  return (
    <MeetingAction
      isSelected={isEnabled}
      isDisabled={status !== AudioCallStatuses.connected}
      icon={isEnabled ? 'videoDark' : 'video'}
      onClick={onToggleVideo}
    />
  );
};

export default CameraButton;
